import { Button, Card, CardBody, CardHeader, Image } from '@nextui-org/react'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { useUTMParams } from '@/hooks/useUTMParams'

import { ContainerPage } from '@/components/common'
import { Icons } from '@/components/icons'

export const EmailSendSuccess = (): JSX.Element => {
    const { t } = useTranslation()
    const [searchParams] = useSearchParams()
    const { navigateWithUTM } = useUTMParams()
    const email = searchParams.get('email')

    return (
        <ContainerPage>
            <article className="p-4 bg-gradient-ean-2 dark:bg-gradient-ean">
                <motion.div
                    initial={{ y: -50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 2, ease: 'easeOut' }}
                    className="flex flex-col justify-center items-center"
                >
                    <Card className="w-full backdrop-blur-md lg:w-4/5 lg:mx-auto lg:my-0 bg-white/90 dark:bg-gray-800/90">
                        <CardHeader className="flex flex-col gap-4 justify-center items-center">
                            <Image
                                src="/LogoEAN.jpg"
                                alt="logo"
                                className="w-[150px]"
                            />
                            <div className="flex items-center gap-3 text-primary">
                                <Icons.Globe className="w-8 h-8" />
                                <h1 className="text-2xl font-bold text-center">
                                    ¡Correo Enviado!
                                </h1>
                            </div>
                        </CardHeader>
                        <CardBody className="flex flex-col items-center gap-6 p-6">
                            <p className="text-center text-default-600 text-lg">
                                Se ha enviado un enlace de verificación a tu
                                correo electrónico.
                            </p>
                            {email && (
                                <p className="text-center text-primary font-medium">
                                    El correo {email} recibirá el enlace de
                                    verificación.
                                </p>
                            )}
                            <p className="text-center text-default-500 text-sm">
                                Revisa tu bandeja de entrada y sigue las
                                instrucciones para verificar tu cuenta.
                            </p>
                            <Button
                                color="primary"
                                className="w-full"
                                onPress={() => navigateWithUTM('/login')}
                            >
                                {t('emailSent.goToLogin')}
                            </Button>
                        </CardBody>
                    </Card>
                </motion.div>
            </article>
        </ContainerPage>
    )
}
